/**
 * Date-extensions locale Maldivian [dv]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('dv', {
    monthNames: ['ޖެނުއަރީ','ފެބްރުއަރީ','މާރިޗު','އޭޕްރީލު','މޭ','ޖޫން','ޖުލައި','އޯގަސްޓު','ސެޕްޓެމްބަރު','އޮކްޓޯބަރު','ނޮވެމްބަރު','ޑިސެމްބަރު'],
    monthShortNames: ['ޖެނުއަރީ','ފެބްރުއަރީ','މާރިޗު','އޭޕްރީލު','މޭ','ޖޫން','ޖުލައި','އޯގަސްޓު','ސެޕްޓެމްބަރު','އޮކްޓޯބަރު','ނޮވެމްބަރު','ޑިސެމްބަރު'],
    dayNames: ['އާދިއްތަ','ހޯމަ','އަންގާރަ','ބުދަ','ބުރާސްފަތި','ހުކުރު','ހޮނިހިރު'],
    dayShortNames: ['އާދިއްތަ','ހޯމަ','އަންގާރަ','ބުދަ','ބުރާސްފަތި','ހުކުރު','ހޮނިހިރު']
});
